import { RootState } from 'rootReducer';

export const errorTripSel = (state: RootState) => state.orderingModuleReducer.tripReducer.error;
export const loadingSel = (state: RootState) => state.orderingModuleReducer.tripReducer.loading;

export const locationSel = (state: RootState) => state.orderingModuleReducer.tripReducer.location;
export const addFaceIDSelector = (state: RootState) => ({
  loadFaceIdAdd: state.orderingModuleReducer.tripReducer.loadFaceIdAdd,
  errorFaceIdAdd: state.orderingModuleReducer.tripReducer.errorFaceIdAdd,
  fieldFaceIdAdd: state.orderingModuleReducer.tripReducer.fieldFaceIdAdd,
});

export const fieldFaceIdAdd = (state: RootState) => state.orderingModuleReducer.tripReducer.fieldFaceIdAdd;
